// src/pages/SalaryPaymenys/salaryPaymentThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSalaryPaymentWithDetailsApi,
  getPaymentCodeApi,
  saveEmployeePaymentApi,
  deleteSalaryPaymentApi,
} from "../../apiservice/hrpayroll";

// fetch list (with details)
export const fetchSalaryPayments = createAsyncThunk(
  "salaryPayments/fetchSalaryPayments",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getSalaryPaymentWithDetailsApi({ oneDate: null });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// fetch new salary payment code
export const fetchSalaryPaymentCode = createAsyncThunk(
  "salaryPayments/fetchSalaryPaymentCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getPaymentCodeApi();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// save salary payment (create / update)
export const saveSalaryPayment = createAsyncThunk(
  "salaryPayments/saveSalaryPayment",
  async (payload, { rejectWithValue }) => {
  try {
      const res = await saveEmployeePaymentApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete salary payment
export const deleteSalaryPayment = createAsyncThunk(
  "salaryPayments/deleteSalaryPayment",
  async (pay_id, { rejectWithValue }) => {
    try {
      const res = await deleteSalaryPaymentApi({ pay_id });
      return { id: pay_id, msg: res.data.msg };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
